module.exports = __webpack_public_path__ + "static/media/dashboard-transaction.2ed22bf8.svg";